import axios from 'axios';
import decode from 'jwt-decode';
// eslint-disable-next-line import/extensions
import Cookies from 'js-cookie';
import { LOGIN, LOGOUT, FIRST_AUTH_DATA } from './types';
import api from '../../../utils/api';
import getTokens from '../../../utils/getTokens';

const UserTokens = getTokens();

export default {
  async userLogin({ commit }, userObj) {
    const { data } = await axios(api.auth.signIn(userObj));
    Cookies.set(
      'userTokens',
      JSON.stringify({
        access: data.access,
        refresh: data.refresh,
      }),
    );
    commit(LOGIN, data);
  },
  async userLogout({ commit }) {
    try {
      Cookies.remove('userTokens');
      commit(LOGOUT);
    } catch (e) {
      console.warn(e);
    }
  },
  async userRegister({}, userObj) {
    await axios(api.auth.signUp(userObj));
  },
  async becomeMember({}, userObj) {
    await axios(api.auth.becomeMember(userObj));
  },
  async setPassword({ commit }, data) {
    const firstAuthData = await axios(api.auth.setPassword(data));
    const response = await axios(
      api.auth.signIn({ username: firstAuthData.data.username, password: data.passwords.password }),
    );
    const customerId = response.data.access ? decode(response.data.access).customer_id : '';
    const userInfo = await axios(api.user.fetch(
      customerId, response.data.access,
    ));
    commit(FIRST_AUTH_DATA, {
      data: {
        customerId,
        email: firstAuthData.data.username,
        adminCompany: userInfo.data.admin_company,
        isFirstLogin: userInfo.data.is_first_login,
        access: response.data.access,
        refresh: response.data.refresh,
      },
    });
  },
  async resendToken({}, data) {
    await axios(api.auth.resendToken(data));
  },
  async userRefresh({ commit, dispatch }) {
    try {
      const response = await axios(api.auth.refresh());
      const userTokens = {
        access: response.data.access,
        refresh: UserTokens ? JSON.parse(UserTokens).refresh : null,
      };
      Cookies.set('userTokens', JSON.stringify(userTokens));
      commit(LOGIN, userTokens);
    } catch (e) {
      console.warn(e);
      dispatch('userLogout');
      Cookies.remove('userTokens');
    }
  },
  async resetPasswordHashVerify({}, hash) {
    await axios(api.auth.verifyResetPasswordHash(hash));
  },
  async addUserFirstSettings({}, data) {
    await axios(api.auth.addUserFirstSettings(data));
  },
  async addCompanyFirstSettings({}, data) {
    await axios(api.auth.addCompanyFirstSettings(data));
  },
  async addCompanyType({}, data) {
    await axios(api.auth.addCompanyType(data));
  },
  firstLogin({ commit }, userObj) {
    const tokens = {
      access: userObj.access,
      refresh: userObj.refresh,
    };
    Cookies.set(
      'userTokens',
      JSON.stringify(tokens),
    );
    commit(LOGIN, tokens);
  },
  async companySettingsSelects(_, type) {
    const { data } = await axios(api.auth.companySettingsSelects(type));
    return data.results;
  },
};
